import React from "react";

type TProps = {
  width?: string;
  height?: string;
  className?: string;
};
export const FooterLogo = ({
  className = "#B058D9",
  height = "69",
  width = "48",
}: TProps) => {
  return (
    <svg
      width="142"
      height="68"
      viewBox="0 0 142 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.1207 7.00642V27.7401H63.9441C64.6502 27.7401 65.3373 27.9691 65.9022 28.3928L70.8929 32.1358L75.8836 28.3928C76.4485 27.9691 77.1355 27.7401 77.8417 27.7401H83.6651V7.00642H58.1207ZM54.8008 6.95003C54.8008 5.14765 56.2619 3.68652 58.0643 3.68652H83.7214C85.5238 3.68652 86.9849 5.14765 86.9849 6.95004V27.7965C86.9849 29.5989 85.5238 31.06 83.7214 31.06H77.8605L72.851 34.8171C71.6906 35.6874 70.0951 35.6874 68.9348 34.8171L63.9253 31.06H58.0643C56.2619 31.06 54.8008 29.5989 54.8008 27.7965V6.95003Z"
        fill="#B058D9"
      />
      <path
        d="M67.6858 21.3824C67.6858 23.1537 66.2499 24.5896 64.4786 24.5896C62.7074 24.5896 61.2715 23.1537 61.2715 21.3824C61.2715 19.6112 62.7074 18.1753 64.4786 18.1753C66.2499 18.1753 67.6858 19.6112 67.6858 21.3824Z"
        fill="#7B21A6"
      />
      <path
        d="M80.5143 21.3824C80.5143 23.1537 79.0784 24.5896 77.3072 24.5896C75.5359 24.5896 74.1 23.1537 74.1 21.3824C74.1 19.6112 75.5359 18.1753 77.3072 18.1753C79.0784 18.1753 80.5143 19.6112 80.5143 21.3824Z"
        fill="#7B21A6"
      />
      <g filter="url(#filter0_di_301_6612)">
        <path
          d="M64.6843 10.1137C61.544 9.72117 58.6441 9.13718 56.265 8.37585C53.842 7.60049 52.1412 6.69747 51.2201 5.77637L48.8726 8.12389C50.3568 9.60814 52.665 10.7096 55.2531 11.5378C57.8851 12.38 60.9986 12.9987 64.2726 13.408C66.4 13.6739 67.5935 14.5802 68.2794 15.4996C68.9979 16.4626 69.2282 17.5363 69.2327 18.1564C69.2327 18.1627 69.2327 18.1689 69.2327 18.1752C69.2327 19.0919 69.9759 19.8351 70.8926 19.8351C71.2078 19.8351 71.5025 19.7473 71.7535 19.5948C71.7763 19.5809 71.7988 19.5665 71.8208 19.5516C72.2624 19.2533 72.5527 18.7481 72.5527 18.1751C72.5527 18.1689 72.5527 18.1627 72.5527 18.1564C72.5572 17.5363 72.7875 16.4626 73.5059 15.4997C74.1919 14.5803 75.3853 13.674 77.5128 13.408C80.7868 12.9988 83.9002 12.3801 86.5322 11.5379C89.1204 10.7096 91.4286 9.60821 92.9128 8.12395L90.5653 5.77643C89.6442 6.69753 87.9434 7.60056 85.5204 8.37591C83.1413 9.13724 80.2413 9.72123 77.101 10.1138C74.1353 10.4845 72.1348 11.8201 70.8927 13.4511C69.6506 11.8201 67.6501 10.4844 64.6843 10.1137Z"
          fill="#B058D9"
        />
      </g>
      <path
        d="M64.1584 59.6508C60.7676 59.6508 58.5002 57.3631 58.5002 53.9518C58.5002 50.6631 60.8697 48.2732 64.138 48.2732C67.7739 48.2732 70.2047 51.2351 69.5715 54.8506H62.1157C62.2996 56.2396 62.9532 56.9341 64.0767 56.9341C65.0572 56.9341 65.7108 56.5256 66.0172 55.7289H69.5102C68.8361 58.2414 66.8956 59.6508 64.1584 59.6508ZM64.0563 50.847C63.0145 50.847 62.4017 51.4394 62.1566 52.665H65.8334C65.7925 51.5619 65.098 50.847 64.0563 50.847Z"
        fill="#301B3A"
      />
      <path
        d="M58.1209 55.7289C58.1209 58.1597 56.3233 59.6713 53.0142 59.6713C49.7051 59.6713 47.9076 58.1189 47.6829 55.586H51.0329C51.0329 56.5052 51.8703 57.0975 53.0755 57.0975C53.8721 57.0975 54.5871 56.9137 54.5871 56.3417C54.5871 55.8515 54.2194 55.6472 53.4636 55.5042L51.2984 55.1161C49.3783 54.7689 48.1527 53.6659 48.1527 51.8887C48.1527 49.7644 49.9502 48.2732 52.8304 48.2732C55.7105 48.2732 57.7123 49.8052 57.9166 52.2564H54.5667C54.4849 51.3781 53.8109 50.847 52.8508 50.847C52.0338 50.847 51.5027 51.0717 51.5027 51.5619C51.5027 52.0317 51.8499 52.1747 52.5444 52.2973L54.8731 52.7262C56.9974 53.1143 58.1209 54.1561 58.1209 55.7289Z"
        fill="#301B3A"
      />
      <path
        d="M47.1681 45.9242C47.1681 47.0681 46.2489 47.9056 44.9211 47.9056C43.5934 47.9056 42.6742 47.0681 42.6742 45.9242C42.6742 44.7599 43.5934 43.9224 44.9211 43.9224C46.2489 43.9224 47.1681 44.7599 47.1681 45.9242ZM46.6982 59.467H43.2053V48.4775H46.6982V59.467Z"
        fill="#301B3A"
      />
      <path
        d="M34.9287 59.467L32.5388 50.3363L30.1489 59.467H26.2474L22.5298 44.8007H26.3087L28.2901 53.5433L30.6187 44.8007H34.5202L36.7671 53.5842L38.7689 44.8007H42.5479L38.8098 59.467H34.9287Z"
        fill="#301B3A"
      />
      <path
        d="M113.597 59.5918C110.206 59.5918 107.938 57.3041 107.938 53.8928C107.938 50.6041 110.308 48.2142 113.576 48.2142C117.212 48.2142 119.643 51.1761 119.01 54.7916H111.554C111.738 56.1806 112.391 56.8751 113.515 56.8751C114.495 56.8751 115.149 56.4666 115.455 55.6699H118.948C118.274 58.1824 116.334 59.5918 113.597 59.5918ZM113.495 50.788C112.453 50.788 111.84 51.3803 111.595 52.6059H115.272C115.231 51.5029 114.536 50.788 113.495 50.788Z"
        fill="#301B3A"
      />
      <path
        d="M107.803 55.9763V59.0199C107.027 59.4488 106.291 59.6123 105.311 59.6123C102.839 59.6123 101.389 58.1415 101.389 55.6291V51.462H99.3462V48.4185H101.389V45.1911H104.882V48.4185H107.884V51.462H104.882V54.812C104.882 55.8742 105.331 56.3644 106.291 56.3644C106.863 56.3644 107.415 56.2214 107.803 55.9763Z"
        fill="#301B3A"
      />
      <path
        d="M96.2453 59.408V58.3458C95.4691 59.2242 94.5091 59.6123 93.0996 59.6123C90.8119 59.6123 89.2799 58.2437 89.2799 56.1602C89.2799 54.0154 91.0161 52.8511 94.1618 52.8511C94.7542 52.8511 95.3057 52.8919 95.7755 52.9736V52.4425C95.7755 51.4825 95.224 50.9514 94.2435 50.9514C93.2835 50.9514 92.7115 51.4825 92.589 52.4425H89.4433C89.6475 49.8892 91.5472 48.2142 94.264 48.2142C97.2871 48.2142 99.0642 49.8483 99.0642 52.6264V59.408H96.2453ZM92.5685 56.058C92.5685 56.773 93.0588 57.2019 93.9167 57.2019C95.081 57.2019 95.7755 56.6504 95.7755 55.7516V55.0571C95.2444 54.955 94.8359 54.9141 94.3865 54.9141C93.2018 54.9141 92.5685 55.3022 92.5685 56.058Z"
        fill="#301B3A"
      />
      <path
        d="M77.999 59.408L74.8533 50.9514V59.408H71.3604V44.7417H75.9155L79.6127 54.6895L83.2895 44.7417H87.8446V59.408H84.3517V50.8493L81.1855 59.408H77.999Z"
        fill="#301B3A"
      />
      <defs>
        <filter
          id="filter0_di_301_6612"
          x="47.8485"
          y="5.77637"
          width="46.0882"
          height="16.1068"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.0241" />
          <feGaussianBlur stdDeviation="0.512048" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_301_6612"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_301_6612"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.0241" />
          <feGaussianBlur stdDeviation="0.512048" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_301_6612"
          />
        </filter>
      </defs>
    </svg>
  );
};
